import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=4ce03031&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xinyu/.jenkins/workspace/vue-Commonality-CMS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce03031')) {
      api.createRecord('4ce03031', component.options)
    } else {
      api.reload('4ce03031', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=4ce03031&", function () {
      api.rerender('4ce03031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/loading.vue"
export default component.exports